export default "__VITE_ASSET__N9xg7IGS__"